import deepmerge from 'deepmerge'

export const merge = (target: any, source: any): object => {
  const mergeOptions = {
    /**
     * @url https://github.com/TehShrike/deepmerge#arraymerge-example-combine-arrays
     */
    arrayMerge: (target, source, options) => {
      const destination = target.slice()

      source.forEach((item, index) => {
        if (typeof destination[index] === 'undefined') {
          destination[index] = options.cloneUnlessOtherwiseSpecified(item, options)
        } else if (options.isMergeableObject(item)) {
          destination[index] = merge(target[index], item, options)
        } else if (target.indexOf(item) === -1) {
          destination.push(item)
        }
      })
      return destination
    },
  }

  return deepmerge(target, source, mergeOptions)
}
